


import '../Styles/Medyaf.css';
import React, {useState} from 'react';
import logo from "../logo.svg"
import { FaUserAlt } from "react-icons/fa";
import vat from "../Images/vat.jpg"
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
function Vat() {
  const { t, i18n } = useTranslation();
    return (
      <div>
        <div className='container-fluid fluid'>
          <p className='vatTitle'>{t("vat.title")}</p>
<div className='vat'style={{marginBottom:"5em"}}>
<img src={vat}/>
  </div>

  </div>  <Footer/></div>
    );
}

export default Vat;
